const part = [
    {
        path: 'member-fund-list',
        name: 'member-fund-list',
        meta: {
            icon: 'md-stats',
            title: '会员资金余额',
            notCache: false,
            access: ['S', 'I'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/member-fund/member-fund-list')
    },
    {
        path: 'member-fun-detail',
        name: 'member-fund-detail',
        meta: {
            icon: 'md-stats',
            title: '会员资金明细',
            notCache: true,
            hideInMenu: true,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/member-fund/member-fund-detail')
    }
];

export default part;
